import { defineMessages } from "react-intl";

const messages = defineMessages({
  deleteComment: {
    defaultMessage: "Delete comment",
    description: "Button content of deleting comment",
  },
  reportComment: {
    defaultMessage: "Report comment",
    description: "Button content of report comment",
  },
});

export default messages;
